import styled from '@emotion/styled';
import { css } from '@emotion/react';

import theme from 'styles/theme';

export type ToggleGroupSize = 'sm' | 'md';

type ButtonProps = {
  $size: ToggleGroupSize;
  $active?: boolean;
  $color?: string;
  $activeColor?: string;
  $activeBackgroundColor?: string;
  $borderColor?: string;
};

const sizeStyles: Record<ToggleGroupSize, ReturnType<typeof css>> = {
  sm: css`
    width: 28px;
    height: 28px;

    svg {
      width: 14px;
      height: 14px;
    }
  `,
  md: css`
    width: 34px;
    height: 34px;

    svg {
      width: 18px;
      height: 18px;
    }
  `,
};

export const Container = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

export const Label = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-size: 14px;
  color: ${theme.colors.primaryText};
`;

export const List = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

export const ToggleButton = styled('button', {
  shouldForwardProp: (prop) => !prop.toString().startsWith('$'),
})<ButtonProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid
    ${({ $active, $borderColor, $activeColor }) =>
      $active
        ? $activeColor || theme.colors.mediumPurple
        : $borderColor || '#D9D9D9'};
  background: ${({ $active, $activeBackgroundColor }) =>
    $active ? $activeBackgroundColor || '#fff' : '#fff'};
  color: ${({ $active, $color, $activeColor }) =>
    $active ? $activeColor || theme.colors.mediumPurple : $color || theme.colors.gray};
  cursor: pointer;
  transition: border-color 0.2s ease, color 0.2s ease, opacity 0.2s ease;

  ${({ $size }) => sizeStyles[$size]}

  &:hover:not(:disabled) {
    opacity: 0.85;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
